import { GiftCsMemo } from '@shared/api/giftCsMemo/giftCsMemo.interface';

export interface CsMemoSplit {
  /** 주문(구매자) 단위 메모 — 쿠폰·배송 ref가 없는 것 */
  order: GiftCsMemo[];
  /** 쿠폰 _id → 그 쿠폰 메모 */
  byCoupon: Map<string, GiftCsMemo[]>;
  /** 배송 _id → 그 배송 메모 */
  byDelivery: Map<string, GiftCsMemo[]>;
  /** 주문 축 전체 (통합 타임라인) */
  all: GiftCsMemo[];
}

const EMPTY: GiftCsMemo[] = [];

/**
 * 주문 축으로 한 번 조회한 메모를 화면 단위별로 가른다.
 * (쿠폰·배송 단위 메모에도 giftOrder가 항상 박혀 있어 한 번의 조회로 전부 커버된다)
 */
export const splitCsMemos = (memos: GiftCsMemo[] | null | undefined): CsMemoSplit => {
  const all = memos ?? EMPTY;
  const order: GiftCsMemo[] = [];
  const byCoupon = new Map<string, GiftCsMemo[]>();
  const byDelivery = new Map<string, GiftCsMemo[]>();

  for (const memo of all) {
    if (memo.giftCoupon) {
      const prev = byCoupon.get(memo.giftCoupon);
      if (prev) prev.push(memo);
      else byCoupon.set(memo.giftCoupon, [memo]);
    } else if (memo.giftDelivery) {
      const prev = byDelivery.get(memo.giftDelivery);
      if (prev) prev.push(memo);
      else byDelivery.set(memo.giftDelivery, [memo]);
    } else {
      order.push(memo);
    }
  }

  return { order, byCoupon, byDelivery, all };
};

export const csMemosFor = (
  map: Map<string, GiftCsMemo[]>,
  id: string,
): GiftCsMemo[] => map.get(id) ?? EMPTY;

/** 쿠폰·배송 문서에서 주문 _id 뽑기 (populate 여부 무관) */
export const csMemoOrderIdOf = (item: { giftOrder?: unknown }): string | undefined => {
  const raw = item.giftOrder;
  if (typeof raw === 'string') return raw || undefined;
  if (raw && typeof raw === 'object') {
    const id = (raw as { _id?: unknown })._id;
    if (typeof id === 'string') return id;
  }
  return undefined;
};

/** 목록 배치 조회용 — 중복 없는 주문 id 목록 */
export const collectCsMemoOrderIds = (
  items: { giftOrder?: unknown }[],
): string[] => {
  const ids = new Set<string>();
  for (const item of items) {
    const id = csMemoOrderIdOf(item);
    if (id) ids.add(id);
  }
  return Array.from(ids);
};
